import { combineReducers } from 'redux';
import { IntlReducer as Intl, IntlProvider } from 'react-redux-multilingual'

// Import custom components
import productReducer from './products';
import cartReducer from './cart';
import filtersReducer from './filters';
import searchFiltersReducer from './searchFilters';
// import wishlistReducer from './wishlist';
import compareReducer from './compare';
import csaReducer from './csaApp';
import landingReducer from './landing';
import productDetailReducer from './productDetail';
import collectionReducer from './collection';
import userReducer from './user';
import tenantReducer from './tenant';
import storeReducer from './store';
import categoryReducer from './category';
import navReducer from './nav';
import pincodeReducer from './pincode';
import updateUserInfoReducer from './updUserInfo';
import updateUserAddrReducer from './updUserAddr';
import checkoutReducer from './checkout';
import orderListReducer from './order';
import  registrationFormsReducer  from './registrationForms';
//contact
import contactReducer from './contact';
import easyRewardsReducer from './easyRewards';
import productCompareReducer from './productCompare';
import orderFulfillmentListReducer from './orderFulfillment';
import returnOrderListReducer from './returnOrder';
import cancelOrderReducer from './cancelOrder';
import wishlistReducer from './wishlist';


const rootReducer = combineReducers({
    data: productReducer,
    collection: collectionReducer,
    landing: landingReducer,
    category: categoryReducer,
    nav: navReducer,
    productDetail : productDetailReducer,
    cart: cartReducer,
    filters: filtersReducer,
    searchFilters: searchFiltersReducer,
    wishlist: wishlistReducer,
    compare: compareReducer,
    csa: csaReducer,
    user: userReducer,
    orders: orderListReducer,
    //contact
    contact :contactReducer,
    easyRewards : easyRewardsReducer,

    productCompare : productCompareReducer,
    orderFulfillment : orderFulfillmentListReducer,
    returnOrder: returnOrderListReducer,
    cancelOrder: cancelOrderReducer,
    updateUser: updateUserInfoReducer,
    updateAddr: updateUserAddrReducer,
    pin: pincodeReducer,
    tenant: tenantReducer,
    store: storeReducer,
    checkout: checkoutReducer,
    registrationDetails : registrationFormsReducer,

    Intl
});

export default rootReducer;